import React, { Component } from 'react';
import { Upload } from 'react-feather';

import FileDrop from 'react-file-drop';

import "./Dropzone.scss";

class Dropzone extends Component {
	render() {
		return (
			<FileDrop
				onDrop={this.props.onDrop}
				onDragOver={(e) => {
					let event = e;
					event.stopPropagation();
					event.preventDefault();
				}}
			>
				<div className={`dropzone${this.props.uploading ? " uploading" : ""}${this.props.className ? " " + this.props.className : ""}${this.props.small ? " dropzone-small" : ""}${this.props.hidden ? " dropzone-hidden" : ""}`} onClick={() => this.fileInput.click()}>
					{this.props.uploading ? (
						<div className="uploading-message">
							{this.props.showUploadingSpinner && <div className="sp-circle" />}
							{this.props.uploadingMessage}
						</div>
					) : (
						<>
							{!this.props.small && <Upload className="upload-icon" />}
							<div className="dropzone-message">{this.props.displayMessage ? this.props.displayMessage : "Drop file here or click to upload"}</div>
							<input
								type="file"
								style={{ display: "none" }}
								onChange={e => { this.props.onDrop(e.target.files) }}
								ref={el => this.fileInput = el}
								multiple
							/>
						</>
					)}
				</div>
			</FileDrop>);
	}
}

export default Dropzone;